import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomersCrmStatisticsAPI from '../../../api/CustomersCrmStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function CustomersCrmTotalCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    CustomersCrmStatisticsAPI.getCustomersTotal({ startTime: timeRange.start, endTime: timeRange.end })
      .then((res) => {
        if (!mounted) return;
        setTotal(res.data?.total || 0);
      })
      .catch(() => {
        if (!mounted) return;
        setTotal(0);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false };
  }, [timeRange.start, timeRange.end]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-20">
        <div className="text-muted-foreground">{t('global.loading') || 'Loading...'}</div>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{total}</p>
      <p className="text-sm text-muted-foreground">{t('stats.customers') || 'Customers'}</p>
    </div>
  );
}

export default CustomersCrmTotalCard;


